import { RootAction } from "../RootAction";

export const beforeRequest = () => {
    return {
        type: RootAction.ClientRequest.BeforeRequest,
    }
}

export const afterRequest = () => {
    return {
        type: RootAction.ClientRequest.AfterRequest,
    }
}
